import {
	PRODUCTS,
	ADD_PRODUCT,
	UPDATE_PRODUCT,
	ADD_PRODUCT_ERROR,
	PRODUCT_DETAILS,
	DELETE_PRODUCT,
	POS_PRODUCT,
	GLOBAL_SEARCH_PRODUCTS,
} from "../types/ProductType";
import { message } from "antd";

const initialState = {
	list: null,
	product: null,
	posProduct: null,
	globalSearchResults: null,
};

const productReducer = (state = initialState, action) => {
	switch (action.type) {
		case PRODUCTS:
			return { ...state, list: action.payload };
		case ADD_PRODUCT:
			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const list = [...state.list];
			list.unshift(action.payload);
			return { ...state, list };

		case UPDATE_PRODUCT:
			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const updatedList = state.list.map((product) =>
				product.id === action.payload.id ? action.payload : product
			);
			return { ...state, list: updatedList };

		case PRODUCT_DETAILS:
			return { ...state, product: action.payload.data };

		case POS_PRODUCT:
			return { ...state, posProduct: action.payload.data };

		case GLOBAL_SEARCH_PRODUCTS:
			return { ...state, globalSearchResults: action.payload };

		case DELETE_PRODUCT:
			const filterProduct = state.list.filter(
				(prod) => prod.id !== parseInt(action.payload) && prod
			);

			return { ...state, list: filterProduct };

		// return {
		//   list: [
		//     ...state.list.filter((sup) => sup.id !== parseInt(action.payload)),
		//   ],
		// };

		case ADD_PRODUCT_ERROR:
			message.error(action.payload);
			return state;
		default:
			return state;
	}
};

export default productReducer;
